// todo: remove paymentOptions form payment flow
export enum PaymentOption {
  Card = 'CARD',
  CryptoMonthly = 'CRYPTO_MONTHLY',
  CryptoQuarterly = 'CRYPTO_QUARTERLY',
  CryptoSemiYearly = 'CRYPTO_SEMI_YEARLY',
  CryptoYearly = 'CRYPTO_YEARLY',
}
